import styles from './Header.module.css';

const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.box}>
        <span className={styles.title}>
          <a title='AI Prompt Chain' href='/' className={styles.link}>
            <span className={styles.logo}>
              <i>AI</i>
            </span>
            <span className={styles.text}>Prompt Chain</span>
          </a>
        </span>
      </div>
    </header>
  );
};

export default Header;
